<template>
  <TheTopbarModalLayout class="diy-topbar__alerts">
    <!-- header -->
    <template #header>
      <span class="diy-topbar__alerts-title">
        {{ $t('ui.generals.notifications_title') }}
      </span>
    </template>
    <!-- content -->
    <template #content>
      <Alerts />
    </template>
  </TheTopbarModalLayout>
</template>

<script>
// Components
import Alerts from 'Modules/Alerts'
import TheTopbarModalLayout from './TheTopbarModalLayout.vue'

export default {
  name: 'TheTopbarNavbarAlerts',

  components: {
    Alerts,
    TheTopbarModalLayout,
  },
}
</script>

<style scoped>
.diy-topbar__alerts {
  padding: 10px 0;
  width: 465px;
  background-color: #fff;
  z-index: 200;
}

.diy-topbar__alerts-title {
  display: block;
  text-align: center;
  font-weight: 700;
  margin-bottom: 0.625rem;
}

.diy-topbar__alerts >>> .diy-topbar__modal-content {
  margin-top: 0;
  padding-top: 0;
}
</style>
